
import { post } from "../../api";
import { authHeader } from "../../utils";

const onPaymentValidate = body => post("postPayment", authHeader(), body);

export { onPaymentValidate };


// WEBPACK FOOTER //
// ./src/stores/RazorpayStore/service.js